module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 20@2x.5f559ed5.png";